import React from "react"
import { useIntl } from "react-intl"
import NavTabs from "components/Shared/NavTabs"
import { useFiltersContext } from "components/Shared/GlobalFilter/context/filtersContext"
import { getMetricForTitles } from "./utils"
import CustomerDescription from "components/Shared/CustomerDescription"
import MetricsValueShareModel from "./components/MetricsValueShareModel"
import "./index.scss"
import VSMTabs from "./VSMTabsConfig"
import SubTitleValueShareModel from "./components/SubTitleValueShareModel"
import { Interval } from "components/Shared/PhronesisCalendar/PhronesisCalendar.domain"
import {
	FilterLevelSelected,
	LevelName,
} from "components/Transactional/Performance/interfaces"
import { mapGlobalFilters } from "components/Shared/GlobalFilter/utils"
import { globalFiltersMapBackendConfig } from "components/Shared/GlobalFilter/constants"

interface ValueShareModelProps {
	period: string
	dateInterval: Interval
	levelName: LevelName
	labelFatherLevelName: string
	onChangeLevelName?: (levelName: LevelName) => void
	filterLevelSelected?: FilterLevelSelected
}

const ValueShareModel = (props: ValueShareModelProps) => {
	const { period, dateInterval } = props
	const { filters: globalFilters, preset } = useFiltersContext()

	const benchmarkGlobalFilters = mapGlobalFilters(
		globalFilters,
		globalFiltersMapBackendConfig
	)

	const intl = useIntl()
	const { quantity, level: metric } = getMetricForTitles(globalFilters)
	const filtersBenchmark = {
		...benchmarkGlobalFilters,
		period,
		...dateInterval,
	}

	return (
		<div className="vsm-module">
			<CustomerDescription dateInterval={dateInterval} />
			<MetricsValueShareModel filtersBenchmark={filtersBenchmark} />
			<NavTabs
				title={intl.formatMessage(
					{ id: "phronesis.transactional.application.commercial.vsm.title" },
					{ metric, quantity }
				)}
				subtitleContent={
					<SubTitleValueShareModel
						time={preset}
						metric={metric}
						quantity={quantity}
					/>
				}
				tabs={VSMTabs(intl)}
			/>
		</div>
	)
}

export default ValueShareModel
